import { render, staticRenderFns } from "./addSubject.vue?vue&type=template&id=fefdc80e&scoped=true&"
import script from "./addSubject.vue?vue&type=script&lang=js&"
export * from "./addSubject.vue?vue&type=script&lang=js&"
import style0 from "./addSubject.vue?vue&type=style&index=0&id=fefdc80e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefdc80e",
  null
  
)

export default component.exports